import { routes } from '../constants';

/**
 * Determines the page source for AI Assistant tracking events based on the current pathname.
 * 
 * @param pathname - The current browser pathname
 * @returns 'reader' if on the reader page, 'mukibude' for the AI Tools page
 */
export const getAIAssistantPageSource = (pathname: string): 'reader' | 'mukibude' => {
  return pathname.startsWith(`/${routes.reader.root}/`) ? 'reader' : 'mukibude';
};
